import Header from "./Header";
import Footer from "./Footer";
import WhatsappFAB from "./WhatsappFAB";

export default function SiteLayout({ children }) {
    return (
        <div className="min-h-screen bg-[#050505] text-white">
            <Header />
            <main className="pt-16 md:pt-20">{children}</main>
            <Footer />
            <WhatsappFAB />
        </div>
    );
}
